import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'
import { getSexName } from '../../dataMaintenance/doctor/doctor'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '病人姓名',
      dataIndex: 'patientName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.patientName ? t.patientName : '-'
      },
    },
    {
      title: '性别',
      dataIndex: 'sex',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return getSexName(Number(t?.sex)) || '-'
      },
    },
    {
      title: '出生日期',
      dataIndex: 'birthDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.birthDate
          ? moment(t.birthDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '报告日期',
      dataIndex: 'reportDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportDate
          ? moment(t.reportDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '记录员',
      dataIndex: 'reportUserName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportUserName ? t.reportUserName : '-'
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.remark ? t.remark : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '9rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              danger
              style={{ marginRight: '6px' }}
              type='primary'
              ghost
              size='small'
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除
            </Button>
          </>
        )
      },
    },
  ]
}
